import { render, staticRenderFns } from "./NoteDelete.vue?vue&type=template&id=36ca4cf7&"
import script from "./NoteDelete.vue?vue&type=script&lang=js&"
export * from "./NoteDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports